import React from 'react';

export default function JurisdictionAgePolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        <h1 className="text-3xl font-bold text-purple-600 mb-6 text-center">
          Jurisdiction & Age Eligibility Policy
        </h1>

        <p className="text-gray-700 mb-8">
          This policy outlines who is allowed to participate inside Million2Trillion (M2T), based on age, legal jurisdiction, and international restrictions.
        </p>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Minimum Age Requirements
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All registered users, service providers, traders, educators, or buyers on M2T must be at least 18 years of age or the legal age of majority in their country of residence.</li>
          <li>Minors (under 18) may not open verified accounts, publish content, or purchase financial services on the platform under any circumstances.</li>
          <li>Parental or guardian accounts are not permitted to bypass minor age restrictions.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Restricted Jurisdictions
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Residents or citizens of countries under global financial sanctions (e.g. FATF blacklists, OFAC sanctions, EU bans, or UN embargo lists) are prohibited from using M2T.</li>
          <li>M2T reserves the right to reject account creation or suspend access for users located in high-risk or legally prohibited regions.</li>
          <li>Global compliance audits may trigger periodic jurisdiction reviews for existing verified members.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          User Certification Requirements
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All users certify they meet both age and jurisdiction eligibility requirements during onboarding registration.</li>
          <li>Providing false or manipulated location data or identity documents will result in permanent account ban.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Compliance With Global Laws
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>M2T fully aligns with global AML, KYC, GDPR, FATF, OFAC, and international financial regulations regarding eligibility, sanctions, and age protection rules.</li>
          <li>We monitor regulatory databases regularly to update allowed jurisdictions and compliance lists.</li>
        </ul>

        <p className="text-gray-500 italic mt-10">
          Verified trust means verified eligibility. M2T protects verified professionals by ensuring only legal, adult, and qualified users may access this financial ecosystem.
        </p>
      </div>
    </div>
  );
}
